module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-71-min.af5e1915.jpg";